import { render, staticRenderFns } from "./UnauthorizedRedemption.vue?vue&type=template&id=1bc7fa00&scoped=true"
import script from "./UnauthorizedRedemption.vue?vue&type=script&lang=js"
export * from "./UnauthorizedRedemption.vue?vue&type=script&lang=js"
import style0 from "./UnauthorizedRedemption.vue?vue&type=style&index=0&id=1bc7fa00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc7fa00",
  null
  
)

export default component.exports